import { IAnnotationConfig } from '@indices/def';
import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 10,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 4,
          day: 10,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 12,
          day: 4,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 18,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 11,
          day: 19,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 1,
          day: 17,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 8,
          day: 25,
        },
      },
      {
        color: 'green',
        date: {
          year: 2019,
          month: 2,
          day: 7,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 16,
        },
      },
      // {
      //   color: 'green',
      //   date: {
      //     year: 2021,
      //     month: 7,
      //     day: 21,
      //   },
      // },
    ],
    IndicePoints: [
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 10,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 4,
          day: 10,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 12,
          day: 4,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 18,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 11,
          day: 19,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 1,
          day: 17,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 8,
          day: 25,
        },
      },
      {
        color: 'green',
        date: {
          year: 2019,
          month: 2,
          day: 7,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 16,
        },
      },
      // {
      //   color: 'green',
      //   date: {
      //     year: 2021,
      //     month: 7,
      //     day: 21,
      //   },
      // },
    ],
  },
};
